import * as types from '../constants/actionTypes';
import initialState from '../reducers/initialState';
import * as list from '../utils/list';

// IMPORTANT: Note that with Redux, state should NEVER be changed.
// State is considered immutable. Instead,
// create a copy of the state passed and set new values on the copy.
// Note that I'm using Object.assign to create a copy of current state
// and update values on the copy.
export default function userTaskReducer(state = initialState.userTasks, action) {
    let newState = state;

    switch (action.type) {
        case types.ASSIGN_USER_TO_TASK:
            if (action.status === 'success'){
                newState = assignUserToTask(state, action.data);
            }
            if (action.status === 'failure'){
                newState = Object.assign({}, state, {
                    error: action.data,
                    loading: false
                });
            }
            return newState;

        case types.CREATE_USERTASK:
            if (action.status === 'success'){
                newState = createUserTask(state, action.data);
            }
            if (action.status === 'failure'){
                newState = Object.assign({}, state, {
                    error: action.data,
                    loading: false
                });
            }
            return newState;

        case types.LOAD_QUOTA_HISTORY_BY_USER_TASK:
            if (action.status === 'success'){
                newState = Object.assign({}, state, {
                    quotaHistories: action.data,
                    loading: false
                });
            }
            if (action.status === 'failure'){
                newState = Object.assign({}, state, {
                    error: action.data,
                    loading: false
                });
            }
            return newState;

        case types.LOAD_USERTASK_BY_ID:
            if (action.status === 'success'){
                newState = Object.assign({}, state, {
                    userTask: action.data,
                    loading: false
                });
            }
            if (action.status === 'failure'){
                newState = Object.assign({}, state, {
                    error: action.data,
                    loading: false
                });
            }
            return newState;

        case types.LOAD_USERTASKS_BY_USER:
            if (action.status === 'success'){
                newState = Object.assign({}, state, {
                    userTasksByUser: action.data,
                    loading: false
                });
            }
            if (action.status === 'failure'){
                newState = Object.assign({}, state, {
                    error: action.data,
                    loading: false
                });
            }
            return newState;

        case types.LOAD_USERTASKS_BY_TASK:
            if (action.status === 'success'){
                newState = Object.assign({}, state, {
                    userTasks: action.data,
                    loading: false
                });
            }
            if (action.status === 'failure'){
                newState = Object.assign({}, state, {
                    error: action.data,
                    loading: false
                });
            }
            return newState;

        case types.PM_LOAD_ALL_USERTASKS:
            if (action.status === 'success'){
                newState = Object.assign({}, state, {
                    userTasks: action.data,
                    loading: false
                });
            }
            if (action.status === 'failure'){
                newState = Object.assign({}, state, {
                    error: action.data,
                    loading: false
                });
            }
            return newState;

        case types.SET_LOADING_FLAG_FOR_USERTASK_STATE:
            return Object.assign({}, state, {
                loading: true
            });

        case types.UNASSIGN_USER_FROM_TASK:
            if (action.status === 'success') {
                newState = unassignUserFromTask(state, action.data);
            }
            if (action.status === 'failure') {
                newState = Object.assign({}, state, {
                   error: action.data,
                   loading: false
                });
            }
            return newState;

        case types.UPDATE_USERTASK_ALIAS:
            if (action.status === 'success'){
                newState = Object.assign({}, state, {
                    loading: false
                });
            }
            if (action.status === 'failure'){
                newState = Object.assign({}, state, {
                    error: action.data,
                    loading: false
                });
            }
            return newState;

        case types.UPDATE_USERTASK_COLOR:
            if (action.status === 'success'){
                newState = updateUserTaskColor(state, action.data);
            }
            if (action.status === 'failure'){
                newState = Object.assign({}, state, {
                    error: action.data,
                    loading: false
                });
            }
            return newState;

        case types.UPDATE_USERTASK_FAVORITE:
            if (action.status === 'success'){
                newState = updateUserTaskFavorite(state, action.data);
            }
            if (action.status === 'failure'){
                newState = Object.assign({}, state, {
                    error: action.data,
                    loading: false
                });
            }
            return newState;

        case types.UPDATE_USERTASK_QUOTA:
            if (action.status === 'success'){
                newState = updateUserTaskQuota(state, action.data);
            }
            if (action.status === 'failure'){
                newState = Object.assign({}, state, {
                    error: action.data,
                    loading: false
                });
            }
            return newState;

        default:
            return state;
    }
}

function assignUserToTask (state, userTask) {
    return Object.assign({}, state, {
        loading: false,
        userTasks: [...state.userTasks, userTask]
    });
}

function createUserTask (state, userTask) {
    return Object.assign({}, state, {
        loading: false,
        userTasks: [...state.userTasks, userTask]
    });
}

function unassignUserFromTask (state, userTaskID) {
    let userTasksList = state.userTasks;
    let userTasksList2 = state.userTasksByUser;

    let userTasksIndex = list.findIndexByID(userTasksList, userTaskID);
    let userTasks = list.remove(userTasksList, userTasksIndex);

    let userTasksIndex2 = list.findIndexByID(userTasksList2, userTaskID);
    let userTasks2 = list.remove(userTasksList2, userTasksIndex2);

    let newState = Object.assign({}, state, {
        loading: false,
        userTasks: userTasks,
        userTasksByUser: userTasks2
    });

    return newState;
}

function updateUserTaskColor (state, userTask) {
        // TODO
    let newState = Object.assign({}, state, {
        loading: false
    });
    return newState;
}

function updateUserTaskFavorite (state, userTask) {
        // TODO
    let newState = Object.assign({}, state, {
        loading: false
    });
    return newState;
}

function updateUserTaskQuota (state, userTaskID, quota) {
        // TODO
    let newState = Object.assign({}, state, {
        loading: false
    });
    return newState;
}


/** WEBPACK FOOTER **
 ** ./src/app/reducers/userTaskReducer.js
 **/